<template>
    <v-col>
      <v-card color="transparent" tile flat width="850">
        <!--手机端-->
        <v-row class="d-sm-none d-flex" no-gutters>
          <v-col cols="6">
            <v-avatar class="mx-3 my-6" height="100" width="150" tile>
            <v-img
              :src="imgSrc"
            ></v-img>
          </v-avatar>
          </v-col>
          <v-col cols="6">
            <div>
            <v-card-title :to="jumpTo" class="subtitle-1 pb-0">{{ title }}</v-card-title>
            <v-card-text  class="subtitle-1 font-weight-regular" >
              <v-row justify="center">
                <v-col class="pr-0">
                  <div class="text--disabled">{{ newsDate }}</div>
                  <v-chip flat depressed pill label color="#C3F3E8">{{ $t('news.name') }}</v-chip>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
          </v-col>
        </v-row>
        <!--非手机端-->
        <v-row class="d-none d-sm-flex">
          <v-col cols="3">
            <v-avatar class="mx-3 my-6" height="100" width="170" tile>
            <v-img
              :src="imgSrc"
            ></v-img>
          </v-avatar>
          </v-col>
          <v-divider vertical class="my-6"></v-divider>
          <v-col cols="8">
            <div>
              <a  :href="jumpTo" target="_blank" class="mx-0 px-1 v-btn v-btn--flat v-btn--router v-btn--text theme--light v-size--default">
                <v-card-title :to="jumpTo" class="subtitle-1 pb-0">{{ title }}</v-card-title>
              </a>

            <v-card-text  class="subtitle-2 font-weight-regular">
              <v-row class="ml-2">
                <v-col cols="3" class="pr-0">
                  <v-chip flat depressed pill small label color="#C3F3E8">{{ $t('news.name') }}</v-chip>
                  <div class="mt-2 text--disabled">{{ newsDate }}</div>
                </v-col>
                <v-col
                  cols="9"
                  class="pl-0"
                >{{ content }}</v-col>
              </v-row>
            </v-card-text>
          </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
</template>

<script>
export default {
  name: "TciNewsDiv",
  props: {
    imgSrc: String,
    title: String,
    content: String,
    newsDate: String,
    jumpTo: String,
  }
};
</script>
